import type { Space } from '@cocoonspace/sdk-js/types/space'
import { memo } from 'react'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Separator } from '@cocoonspace/ui/components/separator'
import { Plural, useLingui } from '@lingui/react/macro'

// import { useSearchSpaces } from '~/domains/search/hooks/use-search-spaces.hook'
import type { QueryFilters } from '../filters/use-search-filters.hook'

export const SpacesGroupHeader = memo(
	({
		label,
		items,
		// isAlternative = false,
		timeSlot,
	}: {
		label?: string
		items: Space[]
		timeSlot: {
			day: QueryFilters['day']
			start: QueryFilters['start']
			end: QueryFilters['end']
		}
		isAlternative?: boolean
	}) => {
		const { t } = useLingui()

		// const { activeAlternative, setIsMapVisible, setActiveAlternative } =
		// 	useSearchSpaces()

		// const onGroupChange = useCallback(() => {
		// 	setIsMapVisible(true)
		// 	setActiveAlternative(label || undefined)

		// 	mapEmitter.emit('map.fitBounds')
		// }, [label, setIsMapVisible, setActiveAlternative])

		const start = dateTimeUtils(timeSlot.start, 'HH:mm')
			.customFormat('hours')
			.replace('h00', 'h')

		return (
			<div className='mb-4 flex w-full flex-row items-center gap-4 px-4 pt-4'>
				{!!label && (
					<>
						<h3 className='text-lg leading-none font-bold'>
							{label === '1d_after' && t`Le lendemain à partir de ${start}`}

							{label === '1d_before' &&
								t`Un jour plus tôt à partir de ${start}`}

							{['1h_after', '1h_before'].includes(label) &&
								t`Le même jour à partir de ${start}`}
						</h3>

						<Separator className='hidden w-full flex-1 md:block' />

						<span className='text-xs text-gray-500'>
							<Plural
								value={items?.length}
								one={`1 espace`}
								other={`# espaces`}
							/>
						</span>
					</>
				)}

				{/* {activeAlternative !== label && (
					<button
						type='button'
						className='text-primary ml-auto hidden shrink-0 text-sm font-bold leading-none md:block'
						onClick={onGroupChange}
					>
						{t`Afficher sur la carte`}
					</button>
				)} */}

				{/* {isAlternative && (
					<Button
						className='md:hidden'
						onClick={onGroupChange}
						variant='outlinePrimary'
					>
						<MapIcon size={16} />
					</Button>
				)} */}
			</div>
		)
	},
)
